module.exports = __webpack_public_path__ + "static/img/img_main_03.7f1761b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/img_main_03.png
// module id = BXLn
// module chunks = 1